import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/pricing/land")({
  beforeLoad: () => {
    throw redirect({ to: "/implementation", replace: true });
  },
});
